import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles((theme) => ({
  root: {
    '& .MuiFilledInput-underline:before, & .MuiFilledInput-underline:after': {
      display: 'none',
    },
    '& .MuiFilledInput-root': {
      borderRadius: theme.spacing(0.5),
    },
    '& .MuiInputAdornment-filled.MuiInputAdornment-positionStart:not(.MuiInputAdornment-hiddenLabel)': {
      marginTop: 0,
      '& .MuiTypography-root': {
        lineHeight: 1.08,
        fontSize: theme.typography.pxToRem(14),
      },
    },
    '& .MuiInputBase-input': {
      lineHeight: 1.08,
      padding: theme.spacing(1, 1.5),
      fontSize: theme.typography.pxToRem(14),
    },
  },
}))
